import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {BluechatLoad, BluechatLoadStatus} from '../../shared/bluechat-load.model';
import {BluechatDelivery} from '../../shared/bluechat-delivery.model';
import {LoadManagementService} from "../../shared/load-management.service";

@Component({
  selector: 'app-bluechat-load',
  templateUrl: './bluechat-load.component.html',
  styleUrls: ['./bluechat-load.component.scss']
})
export class BluechatLoadComponent implements OnChanges {
  @Input() public load: BluechatLoad
  @Input() public userCanCreateNote = false;
  @Input() public carrierHasBluechat = false;
  @Input() public selectedDeliveries: Array<BluechatDelivery>

  @Output() public selectDeliveries = new EventEmitter<Array<BluechatDelivery>>();
  @Output() public createNoteClicked = new EventEmitter<BluechatLoad>();
  @Output() public infoClicked = new EventEmitter<void>();

  public isLoadSelected = false;
  public _selectedDeliveries: { [deliveryNumber: string]: boolean } = {};
  public loadStatusAllowNoteCreation: boolean;

  constructor(private bluechatLoadService: LoadManagementService) {
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('selectedDeliveries') && !changes['selectedDeliveries'].isFirstChange()) {
      this._selectedDeliveries = {};
      changes['selectedDeliveries'].currentValue?.forEach(delivery => this._selectedDeliveries[delivery.deliveryNumber] = true);
      this.isLoadSelected = this.load.deliveries.every(delivery => this._selectedDeliveries[delivery.deliveryNumber]);
    }

    if (changes['load']) {
      this.loadStatusAllowNoteCreation = this.bluechatLoadService.doesLoadStatusAllowsNoteCreation(this.load.status);
    }
  }

  public transformToLoadAndEmit(delivery: BluechatDelivery) {
    this.createNoteClicked.emit({... this.load, deliveries: [delivery]});
  }

  public selectLoad() {
    if (this.isLoadSelected) {
      this.selectDeliveries.emit([]);
    } else {
      this.selectDeliveries.emit(this.load.deliveries);
    }
  }

  public selectDelivery(deliveryNumber: string, status: boolean) {
    this._selectedDeliveries[deliveryNumber] = status;
    this.selectDeliveries.emit(this.load.deliveries.filter(loadDelivery => this._selectedDeliveries[loadDelivery.deliveryNumber]));
  }

  public infoClick($event: Event) {
    $event.stopImmediatePropagation()
    this.infoClicked.emit()
  }
}
